module.exports = __webpack_public_path__ + "img/folder-not-empty.fd7d784a.svg";